import { Box } from "@mui/material";
import styled from "styled-components";

import { colors, globalStyle } from "components";

export const Container = styled.div`
  width: 100%;

  .MuiInputBase-root {
    height: 56px;
    width: 100%;
  }

  .input_mui fieldset {
    border-color: ${globalStyle.input.default};
    font-family: ${globalStyle.fontFamily};
    font-size: 12px;
    border-width: 2px;
  }

  .input_mui:hover fieldset {
    border-color: ${globalStyle.input.hover};
    font-family: ${globalStyle.fontFamily};
  }

  .input_mui .Mui-focused fieldset {
    border-color: ${globalStyle.input.focus};
  }

  .css-i4bv87-MuiSvgIcon-root {
    font-size: 18px;
    color: ${colors.neutral_gray_60};
  }
`;

export const ContainerHeader = styled(Box as any)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 6px;
`;

export const LabelRequired = styled(Box as any)`
  padding: 0;
`;
